import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./VariantSelector.module.scss";
export const VariantSelector = ({ color, label }) => (_jsx("span", { className: styles.container, children: _jsx("span", { "aria-label": label, className: styles.radio, role: "button", style: {
            backgroundColor: color,
        } }) }));
//# sourceMappingURL=VariantSelector.js.map